
export const Home_IMG = {
  hero: require('../Assets/images/heroImages.jpg'),
  ball: require('../Assets/images/ball.webp'),
  CommunityFunSection: require('../Assets/images/community.webp'),
  CommunityFunSection2: require('../Assets/images/GettyImages-1130513015-2.webp'),
  AnnouncementSection1: require('../Assets/images/GettyImages-601922130-1.webp'),
  AnnouncementSection2: require('../Assets/images/GettyImages-1454077635.webp'),
  BackgroundVideoSection1: require('../Assets/images/Rectangle-5-1.webp'),
  BackgroundVideoSection2: require('../Assets/images/GettyImages-1454077635.webp'),
  LocationhoursSection1: require('../Assets/images/gettyimages-1323453475-.webp'),
  
}
export const Programs_IMG = {
  kidsnadultsImage: require('../Assets/images/programs-1.jpg'),
  kidsnadults_2Image: require('../Assets/images/programs-2.jpg'),
  kidsnadults_3Image: require('../Assets/images/programs-3.jpeg'),
  kidsnadults_4Image: require('../Assets/images/programs-4.jpg'),
  kidsnadults_5Image: require('../Assets/images/programs-5.jpeg'),
  kidsnadults_6Image: require('../Assets/images/programs-6.jpeg'),
}

export const OurServices_IMG = {
  Baner_img: require('../Assets/images/GettyImages-1168004452.jpg'),
  kidsnadults_2Image: require('../Assets/images/programs-2.jpg'),
  bottom_banner: require('../Assets/images/ourservices_bottombaner.jpg'),
}

export const ChampionsForge_IMG = {
  ChampionsForge1: require('../Assets/images/ChampionsForge1.jpg'),
  ChampionsForge2: require('../Assets/images/ChampionsForge2.jpg'),
  ChampionsForge3: require('../Assets/images/ChampionsForge3.jpg'),
  ChampionsForge4: require('../Assets/images/ChampionsForge4.jpg'),
  ChampionsForge5: require('../Assets/images/ChampionsForge5.jpg'),
  ChampionsForge6: require('../Assets/images/ChampionsForge6.jpg'),
  ChampionsForge7: require('../Assets/images/ChampionsForge7.jpg'),
  ChampionsForge8: require('../Assets/images/ChampionsForge8.jpg'),
}

export const Contact_IMG = {
  contactBanner: require('../Assets/images/location-banner.jpg'),
}

export const About_IMG = {
  aboutBanner: require('../Assets/images/aboutBanner.jpg'),
  aboutExplore: require('../Assets/images/aboutExplore.jpg'),
  aboutLast: require('../Assets/images/aboutlastIMG.webp'),
  aboutEnroll: require('../Assets/images/aboutEnroll.jpg'),
  motionsection1: require('../Assets/images/GettyImages-2023560374-1024x682.webp'),
  motionsection2: require('../Assets/images/GettyImages-860056396-1024x682.webp'),
  
}